module.exports = __webpack_public_path__ + "img/img2.8dc3e12e.png";